import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ContactBanner } from "../components/SiteShell";
import { IMAGES } from "../assets";

export function KidsPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Executive Jiu-Jitsu Kids | Líderes no Tatame";
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const pillarsList = (t("kids.pillars.items", { returnObjects: true }) as Array<{
    num: string;
    title: string;
    desc: string;
  }>) || [];

  return (
    <main>
      <section className="inner-hero kids-hero">
        <div>
          <p className="eyebrow">{t("kids.hero.eyebrow")}</p>
          <h1>
            {t("kids.hero.title").split(".")[0]}
            <br />
            <em>{t("kids.hero.title")}</em>
          </h1>
          <p>{t("kids.hero.subtitle")}</p>
          <a className="button" href="#metodologia">
            {t("kids.hero.cta")}
          </a>
        </div>
        <div className="kids-hero-logo">
          <div className="kids-logo-halo" aria-hidden="true"></div>
          <div className="kids-logo-wrapper">
            <img src={IMAGES.logo} alt="Logo oficial Executive Jiu-Jitsu" />
          </div>
          <div className="kids-hero-badge">
            <span className="star-icon">★</span>
            <span>{t("kids.hero.badge")}</span>
            <span className="star-icon">★</span>
          </div>
        </div>
      </section>

      <section className="editorial-section" id="metodologia">
        <p className="eyebrow">{t("kids.editorial.eyebrow")}</p>
        <h2>
          {t("kids.editorial.title").split(".")[0]}.
          <br />
          <em>{t("kids.editorial.title").split(".")[1] || ""}</em>
        </h2>
        <div className="editorial-columns">
          <p>{t("kids.editorial.p1")}</p>
          <p>{t("kids.editorial.p2")}</p>
        </div>
      </section>

      <section className="kids-pillars-section">
        <div className="section-intro">
          <p className="eyebrow">{t("kids.pillars.eyebrow")}</p>
          <h2>
            {t("kids.pillars.title").split(".")[0]}.
            <br />
            <em>{t("kids.pillars.title").split(".")[1] || ""}</em>
          </h2>
        </div>
        <div className="kids-pillars-grid">
          {pillarsList.map((p) => (
            <article key={p.num}>
              <span>{p.num}</span>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </article>
          ))}
        </div>
        <div className="kids-promise">
          <strong>{t("kids.pillars.promiseTitle")}</strong>
          <span>{t("kids.pillars.promiseSubtitle")}</span>
        </div>
      </section>

      <section className="family-section">
        <div>
          <p className="eyebrow">{t("kids.family.eyebrow")}</p>
          <h2>
            {t("kids.family.title").split("além")[0]}
            <br />
            <em>{t("kids.family.title")}</em>
          </h2>
        </div>
        <div className="family-benefits">
          <article>
            <h3>{t("kids.family.benefit1Title")}</h3>
            <p>{t("kids.family.benefit1Desc")}</p>
          </article>
          <article>
            <h3>{t("kids.family.benefit2Title")}</h3>
            <p>{t("kids.family.benefit2Desc")}</p>
          </article>
          <article>
            <h3>{t("kids.family.benefit3Title")}</h3>
            <p>{t("kids.family.benefit3Desc")}</p>
          </article>
          <article>
            <h3>{t("kids.family.benefit4Title")}</h3>
            <p>{t("kids.family.benefit4Desc")}</p>
          </article>
        </div>
      </section>

      <section className="kids-schedule">
        <p className="eyebrow">{t("kids.schedule.eyebrow")}</p>
        <h2>
          {t("kids.schedule.title").split("começa")[0]}
          <br />
          <em>{t("kids.schedule.title")}</em>
        </h2>
        <div>
          <article>
            <strong>{t("kids.schedule.whenTitle")}</strong>
            <p>{t("kids.schedule.whenDesc")}</p>
            <span>{t("kids.schedule.whenHours")}</span>
          </article>
          <article>
            <strong>{t("kids.schedule.whereTitle")}</strong>
            <p>{t("kids.schedule.wherePlace")}</p>
            <span>{t("kids.schedule.whereAddress")}</span>
          </article>
        </div>
      </section>

      <ContactBanner kind="kids" />
    </main>
  );
}
